import type { FC, MouseEventHandler, ReactChild } from 'react';

import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { getCurrentMarketingPathParams } from 'src/app/state/selectors';

const mapStateToProps = createStructuredSelector({
  currentMarketingPathParams: getCurrentMarketingPathParams,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface LinkWithQueryProps extends PropsFromRedux {
  to: string;
  children: ReactChild;
  className?: string;
  target?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  ariaLabel?: string;
}

const LinkWithQuery: FC<LinkWithQueryProps> = ({
  to,
  className,
  children,
  target,
  onClick,
  ariaLabel,
  currentMarketingPathParams,
}) => {
  return (
    <Link
      to={`${to}${currentMarketingPathParams ? `?${currentMarketingPathParams}` : ''}`}
      className={className}
      target={target}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {children}
    </Link>
  );
};

export default compose(connector)(LinkWithQuery);
